import { CameraValidationTestResultsIProps } from '../hooks/useCameraValidationTest'
import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'
import { useTranslation } from 'react-i18next'

import { Alert, Box, ColorScheme, Stack, Text } from '@hivewatch/dark'

import {
  MSEVideoPlayer,
  VALIDATION_VIDEO_PLAYER_HEIGHT,
  VALIDATION_VIDEO_PLAYER_WIDTH,
  VideoPlayer,
} from '@/features/video-player'

interface DarkValidateCameraStreamResultsIProps
  extends CameraValidationTestResultsIProps {
  colorScheme: ColorScheme
  deviceId?: string
}

export const DarkValidateCameraStreamResults = ({
  colorScheme,
  deviceId,
  ...testResults
}: DarkValidateCameraStreamResultsIProps) => {
  const { t } = useTranslation()
  const isValid = testResults.url !== undefined
  const isMSEStreamingEnabled = useFeatureFlag(
    FeatureFlag.authenticatedProxyStreaming
  )

  return (
    <Stack gap='16px'>
      <Alert
        colorScheme={colorScheme}
        description={
          isValid
            ? t('devices:crud_validate_success')
            : t('devices:crud_validate_failed')
        }
        title={t('common:status')}
        variant={isValid ? 'success' : 'error'}
      />

      {isValid &&
        (isMSEStreamingEnabled && deviceId ? (
          <MSEVideoPlayer
            autoplay={true}
            cameraId={deviceId}
            placeholderHeight={VALIDATION_VIDEO_PLAYER_HEIGHT}
            placeholderWidth={VALIDATION_VIDEO_PLAYER_WIDTH}
            showControls={false}
          />
        ) : (
          <VideoPlayer
            autoplay={true}
            liveEnabled={true}
            liveOnly={true}
            pipActive={false}
            placeholderHeight={VALIDATION_VIDEO_PLAYER_HEIGHT}
            placeholderWidth={VALIDATION_VIDEO_PLAYER_WIDTH}
            showControls={false}
            showToggleLiveButton={false}
            url={testResults.url!}
          />
        ))}

      {!isValid && testResults.errorMessages !== undefined && (
        <Box>
          <Text fontWeight='600'>{t('devices:crud_validate_errors')}</Text>
          <Stack gap='4px' mt='8px'>
            {testResults.errorMessages.map((message, index) => (
              <Text fontSize='14px' key={`${message}-${index}`}>
                {`- ${message}`}
              </Text>
            ))}
          </Stack>
        </Box>
      )}
    </Stack>
  )
}
